// extracted by mini-css-extract-plugin
module.exports = {"wrap":"rk-z","articleImagesWrap":"sk-z","articleImage":"tk-z","singleImage":"uk-z"};